import { useState, useEffect } from "react";
import Axios from "axios";

const useSchedule = (url) => {
    const [isloading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    const doFetch = async () => {
        if (navigator.onLine) {
            setIsLoading(true);

            Axios.get(url)
                .then(async (response) => {
                    setData(response.data);
                    setIsLoading(false);
                })
                .catch((err) => {
                    setError(err);
                    setIsLoading(false);
                });
        }
    };

    useEffect(() => {
        doFetch();
    }, [url]);

    return {
        isloading,
        error,
        data,
        doFetch: doFetch,
    };
}

export default useSchedule;